import axios from 'axios'
import adjustScore from '@/utils/adjustScore'

const client = axios.create({
  baseURL: `${process.env.VUE_APP_API_BASE_URL}/leaderboard`
})

export default {

  async getMyHighscore ({ userId, opponentId }) {
    const { data } = await client.get(`/${userId}`, { params: { opponentId } })
    if (!data) return false
    return ({
      name: data.userId.name,
      surname: data.userId.surname,
      score: adjustScore(data.score),
      index: data.index
    })
  },

  async getAllHighscores ({ opponentId, limit }) {
    const { data } = await client.get('/', { params: { opponentId, limit } })
    return data.filter(item => !!item.userId).map(item => ({
      name: item.userId.name,
      surname: item.userId.surname,
      score: adjustScore(item.score)
    }))
  }

}
